import { CertificadoService } from './../../services/certificado.service';
import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as forge from 'node-forge';
import { arrayBufferToString } from '../../util/format';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-certificado-gerar',
  templateUrl: './modal-certificado-gerar.component.html',
  styleUrls: ['./modal-certificado-gerar.component.scss'],
})
export class ModalCertificadoGerarComponent implements OnInit {

  @Input() corPrimaria: string;
  @Output() fecharModal = new EventEmitter();

  form: FormGroup = this.formBuilder.group({
    token: new FormControl('', Validators.required),
    chave: new FormControl('', Validators.required),
  });

  fileReader = new FileReader();

  constructor(
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private loading: NgxSpinnerService,
    private certificadoService: CertificadoService
  ) {

  }

  ngOnInit() {

  }

  validar() {

    if (!this.form.valid) {
      this.toast.error('Preencha os campos obrigatórios');
      return;
    }

    if (!(this.form.value.token.length == 8)) {
      this.toast.error('O token deve conter 8 caracteres');
      return;
    }
    if (!(this.form.value.chave.length == 39)) {
      this.toast.error('A chave deve conter 39 caracteres');
      return;
    }

    this.loading.show();
    this.certificadoService.validar(this.form.value.chave, this.form.value.token).then(retorno => {
      this.loading.hide();
      this.fechar({
        gerar: true,
        retorno
      });
    }).catch(err => {
      this.loading.hide();
      console.log('err', err);
      this.fechar({
        gerar: false,
        err
      });
    });
  }

  fechar(data?) {
    this.fecharModal.emit(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-certificado-gerar/modal-certificado-gerar.component.ts